export const StatsFormFields = (hideBlock?: "tracking" | "reference") => {
  const stats = [];

  if (!hideBlock || hideBlock !== "tracking") {
    stats.push({
      component: "Accordion",
      title: "Tracking Analytics",
      className: "tracking-analytics",
      iconLeft: true,
      initialState: false,
      formFields: [
        {
          component: "TrackingInputsLib",
          id: "trackingInputs",
          name: "trackingInputs",
          inputs: [
            {
              label: "google_analytics_label",
              placeholder: "google_analytics_placeholder",
              errorMessage: [
                { rule: "^G-[A-Z0-9]{7,10}$", message: "google_analytics_invalid_format" },
              ],
              name: "googleAnalytics",
              id: "googleAnalytics",
              data_qa: "google-analytics-input",
            },
            {
              label: "facebook_pixel_label",
              placeholder: "facebook_pixel_placeholder",
              errorMessage: [{ rule: "^\\d{10,16}$", message: "google_analytics_invalid_format" }],
              name: "facebookPixel",
              id: "facebookPixel",
              data_qa: "facebook-pixel-input",
            },
            {
              label: "gtm_label",
              placeholder: "gtm_placeholder",
              errorMessage: [
                { rule: "^(GTM|G)-[A-Z0-9]{8}$", message: "google_tag_manager_invalid_format" },
              ],
              name: "GTM",
              id: "GTM",
              data_qa: "gtm-input",
            },
          ],
        },
      ],
    });
  }

  if (!hideBlock || hideBlock !== "reference") {
    stats.push({
      component: "Accordion",
      title: "URL Configuration",
      className: "URLConfiguration",
      iconLeft: true,
      initialState: false,
      formFields: [
        {
          component: "SwitchWithInputLib",
          id: "customReferenceSwitch",
          label: "switch_label",
          checked: true,
          content: "switch_content",
          name: "customReferenceSwitch",
          data_qa: "custom-link-switch",
          warning: "warning_content",
          formFields: [
            {
              component: "InputLib",
              id: "customReference",
              type: "text",
              label: "URL",
              placeholder: "custom_url_placeholder",
              errorMessage: [
                { rule: "required", message: "required_message" },
                { rule: "maxLength", message: "reference_max_length" },
              ],
              name: "customReference",
              data_qa: "custom-link-input",
              defaultValue: "custom_url_placeholder",
            },
          ],
        },
      ],
    });
  }

  return stats;
};
